import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import App from "./components/App";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import IndexPage from "./components/IndexPage";
import { generateChoreographyRoutes } from "./utils/choreographyRoutes";

document.title = "Choreos App";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

// Generate all choreography routes dynamically
const choreographyRoutes = generateChoreographyRoutes();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route index element={<IndexPage />} />
        {choreographyRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<App choreoName={route.choreoFilePath} />}
          />
        ))}
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
